import React from 'react';
import { createPortal } from 'react-dom';
import BackdropStyled from './bundle.esm2.js';
import useIsomorphicLayoutEffect from '../../hooks/bundle.esm.js';
import usePortal from '../../hooks/bundle.esm2.js';

const Backdrop = (props) => {
  const { children, className, opened, onClick, name } = props;
  const { allowScroll = false, opacity = 0.2, color = "#000000" } = props;
  const portalNode = usePortal(name);
  const clickHandler = (e) => {
    const { currentTarget, target } = e;
    if (currentTarget !== target) {
      return;
    }
    onClick == null ? void 0 : onClick();
  };
  useIsomorphicLayoutEffect(() => {
    const body = document.querySelector("body");
    if (!body) {
      return;
    }
    const restore = () => {
      const windowScrollY = -window.scrollY;
      const scrollY = allowScroll ? windowScrollY.toString() : body.style.top;
      body.style.position = "";
      body.style.top = "";
      body.style.overflowY = "";
      window.scrollTo(0, parseInt(scrollY || "0", 10) * -1);
    };
    if (opened) {
      const scrollY = window.scrollY;
      body.style.top = `-${scrollY}px`;
      body.style.bottom = "0px";
      body.style.right = "0px";
      body.style.left = "0px";
      body.style.overflowY = allowScroll ? "" : "scroll";
      body.style.position = allowScroll ? "" : "fixed";
    }
    return restore;
  }, [opened]);
  if (!portalNode)
    return null;
  return createPortal(
    /* @__PURE__ */ React.createElement(BackdropStyled, {
      className: `Backdrop ${className}`,
      onClick: clickHandler,
      opened,
      color,
      opacity
    }, children),
    portalNode
  );
};
Backdrop.defaultProps = {
  className: "",
  allowScroll: false,
  name: "",
  color: "#000000",
  opacity: 0.2
};

export { Backdrop as default };
//# sourceMappingURL=bundle.esm.js.map
